import React from 'react';
import { ArrowUpRight, Link as LinkIcon } from 'lucide-react';

// References & further reading box for an article.
const ArticleReferences = ({ references }) => (
  <div className="mt-12 rounded-2xl border border-white/8 bg-[#0c1119] p-7">
    <div className="flex items-center gap-2">
      <LinkIcon className="w-4 h-4 text-[#e8743b]" />
      <h2 className="dctv-eyebrow text-[#e8743b]">References &amp; further reading</h2>
    </div>
    <ul className="mt-5 space-y-3">
      {references.map((ref, i) => (
        <li key={ref.url}>
          <a href={ref.url} target="_blank" rel="noopener noreferrer" className="group flex items-start gap-2 text-[#cdd2dc] hover:text-[#e8743b] transition-colors">
            <span className="text-[#6b7384] text-sm mt-0.5">{String(i + 1).padStart(2, '0')}</span>
            <span className="text-[15px] leading-snug">{ref.label}</span>
            <ArrowUpRight className="w-4 h-4 mt-0.5 shrink-0 opacity-60 group-hover:opacity-100" />
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export default ArticleReferences;
